import fetchWarehouse from "./fetchWarehouse";
import fetchiWarehouse from "./fetchiWarehouse";
import createWarehouse from "./create";
import updateWarehouse from "./update";
import updateiWarehouse from "./updateiWarehouse";
import deleteWarehouse from "./delete";
import fetchPurchaseOrdersByWarehouse from "./fetchPurchaseOrdersByWarehouse";
import fetchPurchaseOrder from "./fetchPurchaseOrder";
import sendTransferEntry from "./sendTransferEntry";
import fetchStock from "./fetchStock";
import fetchSeparated from "./fetchSeparated";
import fetchResponsibleUsers from "./fetchResponsibleUsers";
import sendEntryWithoutPO from "./sendEntryWithoutPO";
import sendEntryWithoutConfig from "./sendEntryWithoutConfig";
import sendRequisitionSM from "./sendRequisitionSM";
import createSupplyConfig from "./createSupplyConfig";
import newAdjustmentInput from "./newAdjustmentInput";
import adjustmentOutput from "./adjustmentOutput";
import fetchSupplyConfig from "./fetchSupplyConfig";
import fetchEntries from "./fetchEntries";
import fetchMovements from "./fetchMovements";
import fetchRequisitions from "./fetchRequisitions";
import supplyAdjustment from "./supplyAdjustment";
import fetchBinnacle from "./fetchBinnacle";
import updateDeliveryDateODC from "./updateDeliveryDateODC";
import updateSupplyConfig from "./updateSupplyConfig";
import deleteSupplyConfig from "./deleteSupplyConfig";
import fetchSinistersSM from "./fetchSinistersSM";
import fetchOutputRequests from "./fetchOutputRequests";
import fetchExtraOutputRequest from "./fetchExtraOutputRequest";
import releaseMaterial from "./releaseMaterial";
import releaseExtraMaterial from "./releaseExtraMaterial";
import passToPT from "./passToPT";
import sendRequisitionsToPurchase from "./sendRequisitionsToPurchase";
import fetchReturnedAmounts from "./fetchReturnedAmounts";
import approveReEntry from "./approveReEntry";
import fetchStockReport from "./fetchStockReport";
import sendTransfer from "./sendTransfer";
import createRmFromWarehouse from "./createRmFromWarehouse"

import sendPurchaseOrderEntries from "./sendPurchaseOrderEntries";

export default {
  fetchWarehouse,
  fetchiWarehouse,
  createWarehouse,
  updateWarehouse,
  updateiWarehouse,
  deleteWarehouse,
  fetchPurchaseOrder,
  fetchPurchaseOrdersByWarehouse,
  sendTransferEntry,
  fetchStock,
  fetchSeparated,
  fetchResponsibleUsers,
  sendEntryWithoutPO,
  sendEntryWithoutConfig,
  sendRequisitionSM,
  createSupplyConfig,
  newAdjustmentInput,
  adjustmentOutput,
  fetchSupplyConfig,
  fetchMovements,
  fetchEntries,
  supplyAdjustment,
  fetchBinnacle,
  fetchRequisitions,
  updateDeliveryDateODC,
  updateSupplyConfig,
  deleteSupplyConfig,
  fetchSinistersSM,
  fetchOutputRequests,
  fetchExtraOutputRequest,
  releaseMaterial,
  releaseExtraMaterial,
  passToPT,
  sendRequisitionsToPurchase,
  fetchReturnedAmounts,
  approveReEntry,
  fetchStockReport,
  fetchStockReport,
  sendTransfer,
  sendPurchaseOrderEntries,
  createRmFromWarehouse
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/index.js